import React from "react";
import sass from "pages/References/BusinessProcessRegistry/ItemBuisnesTemplate/register.module.sass";
import NewCheckBox from "components-new/NewCheckBox";
import Badge from "components-new/Badge";
import { IRenderData } from "pages/References/BusinessProcessRegistry/ItemBuisnesTemplate/ItemBuisnesTemplate";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import EmptyTable from "pages/References/BusinessProcessRegistry/Components/EmptyTable";

interface IItemTable {
	select: boolean;
	data: IRenderData[];
	checkRow: (id: number) => void;
	uploadArr: number[];
	toggle: (svg: React.MouseEvent<HTMLOrSVGElement>) => void;
	disabled: boolean;
	rule: () => void;
}

const ItemTable: React.FC<IItemTable> = ({ toggle, checkRow, uploadArr, rule, disabled, select, data }) => {
	return data.length ? (
		<table className={select ? sass.tableSelect : sass.table}>
			<tbody>
				{data.map((_, index) => {
					return (
						<React.Fragment key={index}>
							<tr
								onClick={(e) => {
									if (disabled) {
										rule();
										return;
									}
									e.preventDefault();
									select && checkRow(_.fields[0].patternItemId);
								}}>
								{select && (
									<td>
										<div className={sass.checkbox}>
											<NewCheckBox
												checked={uploadArr.includes(_.fields[0].patternItemId)}
												onChange={(e) => {
													e.stopPropagation();
													checkRow(_.fields[0].patternItemId);
												}}
												type={"checkbox"}
											/>
										</div>
									</td>
								)}
								<td rowSpan={_.fields.length}>{_.name}</td>
								<td>{_.fields[0].name}</td>
								<td>{_.fields[0].shortDescription}</td>
								<td>
									<div className={sass.blocks}>
										{!_.fields[0].isEconomic &&
											!_.fields[0].isSocial &&
											!_.fields[0].isEcologic &&
											!_.fields[0].isPolitic &&
											!_.fields[0].isDefense && <span dangerouslySetInnerHTML={{ __html: "&#8212;" }} />}
										{_.fields[0].isEconomic && <Badge color={"#DD0B7C"}>Экономические</Badge>}
										{_.fields[0].isSocial && <Badge color={"#00528C"}>Социальные</Badge>}
										{_.fields[0].isEcologic && <Badge color={"#35A440"}>Экологические</Badge>}
										{_.fields[0].isPolitic && <Badge color={"#00B8B8"}>Политические</Badge>}
										{_.fields[0].isDefense && <Badge color={"#4B06DF"}>Оборонные</Badge>}
									</div>
								</td>
								<td>{_.fields[0].reason}</td>
								<td>
									<div className={sass.blocks}>
										{_.fields[0].isCriticality ? (
											<Badge color={"#DD0B24"}>Критический</Badge>
										) : (
											<Badge color={"#35A440"}>Некритический</Badge>
										)}
									</div>
								</td>
								{!select && (
									<td>
										<ActionMenuIcon
											data-id={JSON.stringify({
												name: _.fields[0].name,
												clazz: _.fields[0].clazz.id,
												criticality: _.fields[0].isCriticality,
												defense: _.fields[0].isDefense,
												ecologic: _.fields[0].isEcologic,
												economic: _.fields[0].isEconomic,
												politic: _.fields[0].isPolitic,
												reason: _.fields[0].reason,
												social: _.fields[0].isSocial,
												sequenceNumber: _.fields[0].sequenceNumber,
												shortDescription: _.fields[0].shortDescription,
												patternId: _.fields[0].patternItemId,
											})}
											onClick={toggle}
										/>
									</td>
								)}
							</tr>
							{/* eslint-disable-next-line array-callback-return */}
							{_.fields.map((_, subIndex) => {
								if (subIndex !== 0) {
									return (
										<tr
											key={subIndex}
											onClick={(e) => {
												if (disabled) {
													rule();
													return;
												}
												e.preventDefault();
												select && checkRow(_.patternItemId);
											}}>
											{select && (
												<td>
													<div className={sass.checkbox}>
														<NewCheckBox
															checked={uploadArr.includes(_.patternItemId)}
															onChange={(e) => {
																e.stopPropagation();
																checkRow(_.patternItemId);
															}}
															type={"checkbox"}
														/>
													</div>
												</td>
											)}
											<td>{_.name}</td>
											<td>{_.shortDescription}</td>
											<td>
												<div className={sass.blocks}>
													{_.isEconomic && <Badge color={"#DD0B7C"}>Экономические</Badge>}
													{_.isSocial && <Badge color={"#00528C"}>Социальные</Badge>}
													{_.isEcologic && <Badge color={"#35A440"}>Экологические</Badge>}
													{_.isPolitic && <Badge color={"#00B8B8"}>Политические</Badge>}
													{_.isDefense && <Badge color={"#4B06DF"}>Оборонные</Badge>}
												</div>
											</td>
											<td>{_.reason}</td>
											<td>
												<div className={sass.blocks}>
													{_.isCriticality ? (
														<Badge color={"#DD0B24"}>Критический</Badge>
													) : (
														<Badge color={"#35A440"}>Некритический</Badge>
													)}
												</div>
											</td>
											{!select && (
												<td>
													<ActionMenuIcon
														data-id={JSON.stringify({
															name: _.name,
															clazz: _.clazz.id,
															criticality: _.isCriticality,
															defense: _.isDefense,
															ecologic: _.isEcologic,
															economic: _.isEconomic,
															politic: _.isPolitic,
															reason: _.reason,
															social: _.isSocial,
															sequenceNumber: _.sequenceNumber,
															patternId: _.patternItemId,
															shortDescription: _.shortDescription,
														})}
														onClick={toggle}
													/>
												</td>
											)}
										</tr>
									);
								}
							})}
						</React.Fragment>
					);
				})}
			</tbody>
		</table>
	) : (
		<EmptyTable>
			<p>Тут пока пусто</p>
			<p>Добавьте бизнес-процессы</p>
		</EmptyTable>
	);
};

export default React.memo(ItemTable);
